import { INPUT, INPUT_TYPES } from '$gbusiness/enums';
import InputRowModel from '$gbusiness/models/inputRow';
import { input } from '$gbusiness/helpers';

export const TARIFF_FORM: Array<InputRowModel> = [
  {
    items: [
      {
        label: 'SCREEN.TARIFF.COLS.NAME',
        value: 'name',
        input: INPUT.TEXT,
        gridSize: 12,
        validation: [input.requiredValidation],
      },
      {
        ...INPUT_TYPES.PERCENT,
        label: 'SCREEN.TARIFF.COLS.NAME',
        decimalPlaces: 4,
        value: 'rate',
        gridSize: 5,
      },
    ],
  },
];
